import React from 'react';
import {createRoot} from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from './serviceWorker';

import { urls } from './constants';

import { MobileMenuProvider } from './contexts/MobileMenuContext';
import Header from './components/Header';
import CallMe from './components/CallMe';
import MainContent from './components/MainContent';
import MainMobileNav from './components/MainMobileNav';

import './css/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
    <React.StrictMode>
        <BrowserRouter basename={urls.basename}>
            <MobileMenuProvider>
                <Header />
                <CallMe />           
                <MainContent />
                <MainMobileNav />
            </MobileMenuProvider>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
